import type { PayloadAction } from "@reduxjs/toolkit";
import { AlertColor } from "@mui/material";

export default function ErrorHandler(response: PayloadAction<unknown>, setSnackBar: (type: AlertColor, message: string) => void) {
  const payload = response.payload as { code?: number; message?: string } | undefined;
  if (!payload) {
    setSnackBar("error", "Something went wrong");
    return false;
  }
  if (payload?.code === 0) {
    setSnackBar("error", payload?.message || "Request failed");
    return false;
  }
  if (payload?.code !== 1 && !payload?.message) {
    setSnackBar("error", payload?.message || "Unexpected server response");
    return false;
  }

  return true;
}
